export interface Plan {
  id: string;
  name: string;
  slug: string;
  description: string;
  commercial_description: string;
  promotional_text: string;
  display_order: number;
  is_active: boolean;
  is_public: boolean;
  is_featured: boolean;
  is_recommended: boolean;
  is_best_value: boolean;
  is_legacy: boolean;
  is_internal: boolean;
  /* Preços */
  price_brl: number;
  price_monthly: number;
  price_annual: number;
  annual_discount_percent: number;
  currency: string;
  periodicity: string;
  trial_available: boolean;
  trial_days: number;
  /* Limites */
  accounts_limit: number;
  cards_limit: number;
  monthly_transactions_limit: number;
  goals_limit: number;
  payees_limit: number;
  /* Módulo Favorecidos */
  can_use_payees_module: boolean;
  /* AI Assistant */
  can_use_ai_assistant: boolean;
  ai_monthly_questions_limit: number;
  can_use_ai_advanced_insights: boolean;
  can_use_ai_proactive_alerts: boolean;
  /* Recursos */
  reports_enabled: boolean;
  can_export_csv: boolean;
  can_export_pdf: boolean;
  can_access_advanced_insights: boolean;
  can_use_multiple_currencies: boolean;
  can_access_loans_module: boolean;
  can_access_recurring_advanced: boolean;
  can_access_priority_support: boolean;
  /* Módulo Insights */
  can_access_insights_module: boolean;
  insights_level: 'basic' | 'advanced' | 'full';
  max_insights_per_period: number;
  can_access_historical_insights: boolean;
  can_access_recommendations: boolean;
  /* Cobrança */
  monthly_billing_enabled: boolean;
  annual_billing_enabled: boolean;
  auto_renewal_default: boolean;
  grace_days: number;
  overdue_behavior: string;
}

export const EMPTY_PLAN: Omit<Plan, 'id'> = {
  name: '',
  slug: '',
  description: '',
  commercial_description: '',
  promotional_text: '',
  display_order: 0,
  is_active: true,
  is_public: true,
  is_featured: false,
  is_recommended: false,
  is_best_value: false,
  is_legacy: false,
  is_internal: false,
  price_brl: 0,
  price_monthly: 0,
  price_annual: 0,
  annual_discount_percent: 0,
  currency: 'BRL',
  periodicity: 'monthly',
  trial_available: false,
  trial_days: 0,
  accounts_limit: 1,
  cards_limit: 1,
  monthly_transactions_limit: 30,
  goals_limit: 2,
  payees_limit: 5,
  can_use_payees_module: true,
  can_use_ai_assistant: true,
  ai_monthly_questions_limit: 10,
  can_use_ai_advanced_insights: false,
  can_use_ai_proactive_alerts: false,
  reports_enabled: false,
  can_export_csv: false,
  can_export_pdf: false,
  can_access_advanced_insights: false,
  can_use_multiple_currencies: false,
  can_access_loans_module: false,
  can_access_recurring_advanced: false,
  can_access_priority_support: false,
  /* Módulo Insights */
  can_access_insights_module: true,
  insights_level: 'basic',
  max_insights_per_period: 3,
  can_access_historical_insights: false,
  can_access_recommendations: false,
  monthly_billing_enabled: true,
  annual_billing_enabled: false,
  auto_renewal_default: true,
  grace_days: 3,
  overdue_behavior: 'downgrade',
};
